import { createStore } from 'vuex'

export default createStore({
  state: {
    loginState: false,
  },
  getters: {
  },
  mutations: {
    setLoginState(state, value) {
      state.loginState = value;
    }
  },
  actions: {
  },
  modules: {
  }
})
